import { url } from "../utils/utils";
import traceServiceApi from "./traceService-api";


class TraceService {
  getTraces = (requestId: string) => {
    const url = `/BigQuery-Trace?requestId=${requestId}`;
    return traceServiceApi.get(url);
  };

  getTraceDetails = (queryParam: string) => {
    const url = `/traces/${queryParam}`;
    return traceServiceApi.get(url);
  };
  getTraceLogs = (severity: number, requestId: string,startTime:string,endTime:string,filterQuery:any) => {
    let count=100;
    const urlv = "/BigQuery-Log?"+ url`requestId=${requestId}&startTime=${startTime}&endTime=${endTime}&count=${count}&filterQuery=${filterQuery}`;
    return traceServiceApi.get(urlv);
  };
}

export default new TraceService();
